import { render } from "./TempContainer.vue?vue&type=template&id=080aa374"
import script from "./TempContainer.vue?vue&type=script&lang=js"
export * from "./TempContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__